import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useNavigate } from "react-router-dom";
import "./StressCheck.css";

const StressCheck = () => {
  const navigate = useNavigate();
  const [checks, setChecks] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState("");
  const [newCheck, setNewCheck] = useState({
    title: "",
    form_url: "",
    start_date: "",
    end_date: "",
    description: ""
  });
  const [submitError, setSubmitError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});

  const fetchChecks = () => {
    setListError("");
    setListLoading(true);
    api.get("/stresschecks/")
      .then((res) => { setChecks(res.data || []); setListError(""); })
      .catch(() => { setChecks([]); setListError("一覧の取得に失敗しました。"); })
      .finally(() => setListLoading(false));
  };

  useEffect(() => { fetchChecks(); }, []);

  const validate = () => {
    const err = {};
    if (!newCheck.title?.trim()) err.title = "タイトルを入力してください。";
    if (!newCheck.form_url?.trim()) {
      err.form_url = "Google Formsリンクを入力してください。";
    } else {
      try {
        const u = new URL(newCheck.form_url.trim());
        if (!/^https?:/.test(u.protocol)) err.form_url = "URLは https: または http: で始めてください。";
      } catch {
        err.form_url = "Google FormsリンクのURL形式が正しくありません。";
      }
    }
    if (!newCheck.start_date) err.start_date = "開始日を選択してください。";
    if (!newCheck.end_date) err.end_date = "終了日を選択してください。";
    if (newCheck.start_date && newCheck.end_date && newCheck.start_date > newCheck.end_date) {
      err.end_date = "終了日は開始日以降にしてください。";
    }
    setFieldErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    setSubmitError("");
    setFieldErrors({});
    if (!validate()) return;
    try {
      await api.post("/stresschecks/", newCheck);
      setNewCheck({ title: "", form_url: "", start_date: "", end_date: "", description: "" });
      fetchChecks();
      setSubmitError("");
    } catch (err) {
      const data = err?.response?.data;
      const msg =
        (Array.isArray(data?.title) && data.title[0]) ||
        (Array.isArray(data?.form_url) && data.form_url[0]) ||
        data?.detail ||
        data?.error ||
        (data?.form_url && (typeof data.form_url === "string" ? data.form_url : data.form_url[0])) ||
        "作成に失敗しました。入力内容を確認してください。";
      setSubmitError(msg);
    }
  };

  return (
    <div className="stress-admin stress-admin-one-screen">
      <div className="stress-admin-header-row">
        <h2 className="stress-admin-heading">ストレスチェック管理</h2>
        <button type="button" className="stress-admin-back-btn" onClick={() => navigate("/dashboard")}>
          戻る
        </button>
      </div>
      <div className="stress-admin-body">
      <form className="stress-form" onSubmit={handleSubmit}>
        <div className="stress-form-grid">
          <div className="stress-field stress-field-full">
            <label htmlFor="stress-title">タイトル</label>
            <input
              id="stress-title"
              type="text"
              placeholder="例：2025年度 ストレスチェック"
              value={newCheck.title}
              onChange={(e) => setNewCheck({ ...newCheck, title: e.target.value })}
            />
            {fieldErrors.title && <span className="stress-field-error">{fieldErrors.title}</span>}
          </div>
          <div className="stress-field stress-field-full">
            <label htmlFor="stress-form-url">Google Formsリンク（アンケートURL）</label>
            <input
              id="stress-form-url"
              type="url"
              placeholder="https://forms.google.com/..."
              value={newCheck.form_url}
              onChange={(e) => setNewCheck({ ...newCheck, form_url: e.target.value })}
            />
            {fieldErrors.form_url && <span className="stress-field-error">{fieldErrors.form_url}</span>}
          </div>
          <div className="stress-field">
            <label htmlFor="stress-start">実施期間（開始日）</label>
            <input
              id="stress-start"
              type="date"
              value={newCheck.start_date}
              onChange={(e) => setNewCheck({ ...newCheck, start_date: e.target.value })}
            />
            {fieldErrors.start_date && <span className="stress-field-error">{fieldErrors.start_date}</span>}
          </div>
          <div className="stress-field">
            <label htmlFor="stress-end">実施期間（終了日）</label>
            <input
              id="stress-end"
              type="date"
              value={newCheck.end_date}
              onChange={(e) => setNewCheck({ ...newCheck, end_date: e.target.value })}
            />
            {fieldErrors.end_date && <span className="stress-field-error">{fieldErrors.end_date}</span>}
          </div>
          <div className="stress-field stress-field-full">
            <label htmlFor="stress-desc">説明・備考</label>
            <textarea
              id="stress-desc"
              placeholder="任意：説明やメモ"
              value={newCheck.description}
              onChange={(e) => setNewCheck({ ...newCheck, description: e.target.value })}
              rows={3}
            />
          </div>
        </div>
        {submitError && <div className="stress-submit-error">{submitError}</div>}
        <div className="stress-submit-wrap">
          <button type="submit" className="stress-btn-submit">作成</button>
        </div>
      </form>

      <section className="stress-list-section">
      <h3>ストレスチェックリスト</h3>
      {listLoading ? (
        <p className="stress-list-loading">読み込み中...</p>
      ) : (
        <>
      {listError && <p className="stress-list-error">{listError}</p>}
      <ul className="stress-list">
        {checks.map((c) => (
          <li key={c.id}>
            {c.form_url ? (
              <a href={c.form_url} target="_blank" rel="noreferrer" className="stress-list-title-link">
                <b>{c.title}</b>
              </a>
            ) : (
              <b>{c.title}</b>
            )}
            <span className="stress-list-period"> {c.start_date} ～ {c.end_date}</span>
            {c.form_url && (
              <a href={c.form_url} target="_blank" rel="noreferrer" className="stress-list-form-link">
                フォームを開く
              </a>
            )}
          </li>
        ))}
      </ul>
        </>
      )}
      </section>
      </div>
    </div>
  );
};

export default StressCheck;
